// extracted by mini-css-extract-plugin
export default {"contentContainer":"AccountTemplateModal_contentContainer__MFUj1"};